// Generated by run_ocean_color_daily.py; do not edit by hand.
export const oceanColorDates = {
  "palau": {
    "chlorophyll": [
      "1997-09-04",
      "1997-10-01",
      "1997-11-01",
      "1997-12-01",
      "1998-01-01",
      "1998-02-01",
      "1998-03-01",
      "1998-04-01",
      "1998-05-01",
      "1998-06-01",
      "1998-07-01",
      "1998-08-01",
      "1998-09-01",
      "1998-10-01",
      "1998-11-01",
      "1998-12-01",
      "1999-01-01",
      "1999-02-01",
      "1999-03-01",
      "1999-04-01",
      "1999-05-01",
      "1999-06-01",
      "1999-07-01",
      "1999-08-01",
      "1999-09-01",
      "1999-10-01",
      "1999-11-01",
      "1999-12-01",
      "2000-01-01",
      "2000-02-01",
      "2000-03-01",
      "2000-04-01",
      "2000-05-01",
      "2000-06-01",
      "2000-07-01",
      "2000-08-01",
      "2000-09-01",
      "2000-10-01",
      "2000-11-01",
      "2000-12-01",
      "2001-01-01",
      "2001-02-01",
      "2001-03-01",
      "2001-04-01",
      "2001-05-01",
      "2001-06-01",
      "2001-07-01",
      "2001-08-01",
      "2001-09-01",
      "2001-10-01",
      "2001-11-01",
      "2001-12-01",
      "2002-01-01",
      "2002-02-01",
      "2002-03-01",
      "2002-04-01",
      "2002-05-01",
      "2002-06-01",
      "2002-07-01",
      "2002-08-01",
      "2002-09-01",
      "2002-10-01",
      "2002-11-01",
      "2002-12-01",
      "2003-01-01",
      "2003-02-01",
      "2003-03-01",
      "2003-04-01",
      "2003-05-01",
      "2003-06-01",
      "2003-07-01",
      "2003-08-01",
      "2003-09-01",
      "2003-10-01",
      "2003-11-01",
      "2003-12-01",
      "2004-01-01",
      "2004-02-01",
      "2004-03-01",
      "2004-04-01",
      "2004-05-01",
      "2004-06-01",
      "2004-07-01",
      "2004-08-01",
      "2004-09-01",
      "2004-10-01",
      "2004-11-01",
      "2004-12-01",
      "2005-01-01",
      "2005-02-01",
      "2005-03-01",
      "2005-04-01",
      "2005-05-01",
      "2005-06-01",
      "2005-07-01",
      "2005-08-01",
      "2005-09-01",
      "2005-10-01",
      "2005-11-01",
      "2005-12-01",
      "2006-01-01",
      "2006-02-01",
      "2006-03-01",
      "2006-04-01",
      "2006-05-01",
      "2006-06-01",
      "2006-07-01",
      "2006-08-01",
      "2006-09-01",
      "2006-10-01",
      "2006-11-01",
      "2006-12-01",
      "2007-01-01",
      "2007-02-01",
      "2007-03-01",
      "2007-04-01",
      "2007-05-01",
      "2007-06-01",
      "2007-07-01",
      "2007-08-01",
      "2007-09-01",
      "2007-10-01",
      "2007-11-01",
      "2007-12-01",
      "2008-01-01",
      "2008-02-01",
      "2008-03-01",
      "2008-04-01",
      "2008-05-01",
      "2008-06-01",
      "2008-07-01",
      "2008-08-01",
      "2008-09-01",
      "2008-10-01",
      "2008-11-01",
      "2008-12-01",
      "2009-01-01",
      "2009-02-01",
      "2009-03-01",
      "2009-04-01",
      "2009-05-01",
      "2009-06-01",
      "2009-07-01",
      "2009-08-01",
      "2009-09-01",
      "2009-10-01",
      "2009-11-01",
      "2009-12-01",
      "2010-01-01",
      "2010-02-01",
      "2010-03-01",
      "2010-04-01",
      "2010-05-01",
      "2010-06-01",
      "2010-07-01",
      "2010-08-01",
      "2010-09-01",
      "2010-10-01",
      "2010-11-01",
      "2010-12-01",
      "2011-01-01",
      "2011-02-01",
      "2011-03-01",
      "2011-04-01",
      "2011-05-01",
      "2011-06-01",
      "2011-07-01",
      "2011-08-01",
      "2011-09-01",
      "2011-10-01",
      "2011-11-01",
      "2011-12-01",
      "2012-01-01",
      "2012-02-01",
      "2012-03-01",
      "2012-04-01",
      "2012-05-01",
      "2012-06-01",
      "2012-07-01",
      "2012-08-01",
      "2012-09-01",
      "2012-10-01",
      "2012-11-01",
      "2012-12-01",
      "2013-01-01",
      "2013-02-01",
      "2013-03-01",
      "2013-04-01",
      "2013-05-01",
      "2013-06-01",
      "2013-07-01",
      "2013-08-01",
      "2013-09-01",
      "2013-10-01",
      "2013-11-01",
      "2013-12-01",
      "2014-01-01",
      "2014-02-01",
      "2014-03-01",
      "2014-04-01",
      "2014-05-01",
      "2014-06-01",
      "2014-07-01",
      "2014-08-01",
      "2014-09-01",
      "2014-10-01",
      "2014-11-01",
      "2014-12-01",
      "2015-01-01",
      "2015-02-01",
      "2015-03-01",
      "2015-04-01",
      "2015-05-01",
      "2015-06-01",
      "2015-07-01",
      "2015-08-01",
      "2015-09-01",
      "2015-10-01",
      "2015-11-01",
      "2015-12-01",
      "2016-01-01",
      "2016-02-01",
      "2016-03-01",
      "2016-04-01",
      "2016-05-01",
      "2016-06-01",
      "2016-07-01",
      "2016-08-01",
      "2016-09-01",
      "2016-10-01",
      "2016-11-01",
      "2016-12-01",
      "2017-01-01",
      "2017-02-01",
      "2017-03-01",
      "2017-04-01",
      "2017-05-01",
      "2017-06-01",
      "2017-07-01",
      "2017-08-01",
      "2017-09-01",
      "2017-10-01",
      "2017-11-01",
      "2017-12-01",
      "2018-01-01",
      "2018-02-01",
      "2018-03-01",
      "2018-04-01",
      "2018-05-01",
      "2018-06-01",
      "2018-07-01",
      "2018-08-01",
      "2018-09-01",
      "2018-10-01",
      "2018-11-01",
      "2018-12-01",
      "2019-01-01",
      "2019-02-01",
      "2019-03-01",
      "2019-04-01",
      "2019-05-01",
      "2019-06-01",
      "2019-07-01",
      "2019-08-01",
      "2019-09-01",
      "2019-10-01",
      "2019-11-01",
      "2019-12-01",
      "2020-01-01",
      "2020-02-01",
      "2020-03-01",
      "2020-04-01",
      "2020-05-01",
      "2020-06-01",
      "2020-07-01",
      "2020-08-01",
      "2020-09-01",
      "2020-10-01",
      "2020-11-01",
      "2020-12-01",
      "2021-01-01",
      "2021-02-01",
      "2021-03-01",
      "2021-04-01",
      "2021-05-01",
      "2021-06-01",
      "2021-07-01",
      "2021-08-01",
      "2021-09-01",
      "2021-10-01",
      "2021-11-01",
      "2021-12-01",
      "2022-01-01",
      "2022-02-01",
      "2022-03-01",
      "2022-04-01",
      "2022-05-01",
      "2022-06-01",
      "2022-07-01",
      "2022-08-01",
      "2022-09-01",
      "2022-10-01",
      "2022-11-01",
      "2022-12-01",
      "2023-01-01",
      "2023-02-01",
      "2023-03-01",
      "2023-04-01",
      "2023-05-01",
      "2023-06-01",
      "2023-07-01",
      "2023-08-01",
      "2023-09-01",
      "2023-10-01",
      "2023-11-01",
      "2023-12-01",
      "2024-01-01",
      "2024-02-01",
      "2024-03-01",
      "2024-04-01",
      "2024-05-01",
      "2024-06-01",
      "2024-07-01",
      "2024-08-01",
      "2024-09-01",
      "2024-10-01",
      "2024-11-01",
      "2024-12-01",
      "2025-01-01",
      "2025-02-01",
      "2025-03-01",
      "2025-04-01",
      "2025-05-01",
      "2025-06-01",
      "2025-07-01",
      "2025-08-01",
      "2025-09-01",
      "2025-10-01",
      "2025-11-01",
      "2025-12-01",
      "2026-01-01",
      "2026-02-01",
      "2026-03-01",
      "2026-04-01",
      "2026-05-01",
      "2026-06-01"
    ],
    "phytoplankton_size": [
      "1998-01-01",
      "1998-02-01",
      "1998-03-01",
      "1998-04-01",
      "1998-05-01",
      "1998-06-01",
      "1998-07-01",
      "1998-08-01",
      "1998-09-01",
      "1998-10-01",
      "1998-11-01",
      "1998-12-01",
      "1999-01-01",
      "1999-02-01",
      "1999-03-01",
      "1999-04-01",
      "1999-05-01",
      "1999-06-01",
      "1999-07-01",
      "1999-08-01",
      "1999-09-01",
      "1999-10-01",
      "1999-11-01",
      "1999-12-01",
      "2000-01-01",
      "2000-02-01",
      "2000-03-01",
      "2000-04-01",
      "2000-05-01",
      "2000-06-01",
      "2000-07-01",
      "2000-08-01",
      "2000-09-01",
      "2000-10-01",
      "2000-11-01",
      "2000-12-01",
      "2001-01-01",
      "2001-02-01",
      "2001-03-01",
      "2001-04-01",
      "2001-05-01",
      "2001-06-01",
      "2001-07-01",
      "2001-08-01",
      "2001-09-01",
      "2001-10-01",
      "2001-11-01",
      "2001-12-01",
      "2002-01-01",
      "2002-02-01",
      "2002-03-01",
      "2002-04-01",
      "2002-05-01",
      "2002-06-01",
      "2002-07-01",
      "2002-08-01",
      "2002-09-01",
      "2002-10-01",
      "2002-11-01",
      "2002-12-01",
      "2003-01-01",
      "2003-02-01",
      "2003-03-01",
      "2003-04-01",
      "2003-05-01",
      "2003-06-01",
      "2003-07-01",
      "2003-08-01",
      "2003-09-01",
      "2003-10-01",
      "2003-11-01",
      "2003-12-01",
      "2004-01-01",
      "2004-02-01",
      "2004-03-01",
      "2004-04-01",
      "2004-05-01",
      "2004-06-01",
      "2004-07-01",
      "2004-08-01",
      "2004-09-01",
      "2004-10-01",
      "2004-11-01",
      "2004-12-01",
      "2005-01-01",
      "2005-02-01",
      "2005-03-01",
      "2005-04-01",
      "2005-05-01",
      "2005-06-01",
      "2005-07-01",
      "2005-08-01",
      "2005-09-01",
      "2005-10-01",
      "2005-11-01",
      "2005-12-01",
      "2006-01-01",
      "2006-02-01",
      "2006-03-01",
      "2006-04-01",
      "2006-05-01",
      "2006-06-01",
      "2006-07-01",
      "2006-08-01",
      "2006-09-01",
      "2006-10-01",
      "2006-11-01",
      "2006-12-01",
      "2007-01-01",
      "2007-02-01",
      "2007-03-01",
      "2007-04-01",
      "2007-05-01",
      "2007-06-01",
      "2007-07-01",
      "2007-08-01",
      "2007-09-01",
      "2007-10-01",
      "2007-11-01",
      "2007-12-01",
      "2008-01-01",
      "2008-02-01",
      "2008-03-01",
      "2008-04-01",
      "2008-05-01",
      "2008-06-01",
      "2008-07-01",
      "2008-08-01",
      "2008-09-01",
      "2008-10-01",
      "2008-11-01",
      "2008-12-01",
      "2009-01-01",
      "2009-02-01",
      "2009-03-01",
      "2009-04-01",
      "2009-05-01",
      "2009-06-01",
      "2009-07-01",
      "2009-08-01",
      "2009-09-01",
      "2009-10-01",
      "2009-11-01",
      "2009-12-01",
      "2010-01-01",
      "2010-02-01",
      "2010-03-01",
      "2010-04-01",
      "2010-05-01",
      "2010-06-01",
      "2010-07-01",
      "2010-08-01",
      "2010-09-01",
      "2010-10-01",
      "2010-11-01",
      "2010-12-01",
      "2011-01-01",
      "2011-02-01",
      "2011-03-01",
      "2011-04-01",
      "2011-05-01",
      "2011-06-01",
      "2011-07-01",
      "2011-08-01",
      "2011-09-01",
      "2011-10-01",
      "2011-11-01",
      "2011-12-01",
      "2012-01-01",
      "2012-02-01",
      "2012-03-01",
      "2012-04-01",
      "2012-05-01",
      "2012-06-01",
      "2012-07-01",
      "2012-08-01",
      "2012-09-01",
      "2012-10-01",
      "2012-11-01",
      "2012-12-01",
      "2013-01-01",
      "2013-02-01",
      "2013-03-01",
      "2013-04-01",
      "2013-05-01",
      "2013-06-01",
      "2013-07-01",
      "2013-08-01",
      "2013-09-01",
      "2013-10-01",
      "2013-11-01",
      "2013-12-01",
      "2014-01-01",
      "2014-02-01",
      "2014-03-01",
      "2014-04-01",
      "2014-05-01",
      "2014-06-01",
      "2014-07-01",
      "2014-08-01",
      "2014-09-01",
      "2014-10-01",
      "2014-11-01",
      "2014-12-01",
      "2015-01-01",
      "2015-02-01",
      "2015-03-01",
      "2015-04-01",
      "2015-05-01",
      "2015-06-01",
      "2015-07-01",
      "2015-08-01",
      "2015-09-01",
      "2015-10-01",
      "2015-11-01",
      "2015-12-01",
      "2016-01-01",
      "2016-02-01",
      "2016-03-01",
      "2016-04-01",
      "2016-05-01",
      "2016-06-01",
      "2016-07-01",
      "2016-08-01",
      "2016-09-01",
      "2016-10-01",
      "2016-11-01",
      "2016-12-01",
      "2017-01-01",
      "2017-02-01",
      "2017-03-01",
      "2017-04-01",
      "2017-05-01",
      "2017-06-01",
      "2017-07-01",
      "2017-08-01",
      "2017-09-01",
      "2017-10-01",
      "2017-11-01",
      "2017-12-01",
      "2018-01-01",
      "2018-02-01",
      "2018-03-01",
      "2018-04-01",
      "2018-05-01",
      "2018-06-01",
      "2018-07-01",
      "2018-08-01",
      "2018-09-01",
      "2018-10-01",
      "2018-11-01",
      "2018-12-01",
      "2019-01-01",
      "2019-02-01",
      "2019-03-01",
      "2019-04-01",
      "2019-05-01",
      "2019-06-01",
      "2019-07-01",
      "2019-08-01",
      "2019-09-01",
      "2019-10-01",
      "2019-11-01",
      "2019-12-01",
      "2020-01-01",
      "2020-02-01",
      "2020-03-01",
      "2020-04-01",
      "2020-05-01",
      "2020-06-01",
      "2020-07-01",
      "2020-08-01",
      "2020-09-01",
      "2020-10-01",
      "2020-11-01",
      "2020-12-01",
      "2021-01-01",
      "2021-02-01",
      "2021-03-01",
      "2021-04-01",
      "2021-05-01",
      "2021-06-01",
      "2021-07-01",
      "2021-08-01",
      "2021-09-01",
      "2021-10-01",
      "2021-11-01",
      "2021-12-01",
      "2022-01-01",
      "2022-02-01",
      "2022-03-01",
      "2022-04-01",
      "2022-05-01",
      "2022-06-01",
      "2022-07-01",
      "2022-08-01",
      "2022-09-01",
      "2022-10-01",
      "2022-11-01",
      "2022-12-01",
      "2023-01-01",
      "2023-02-01",
      "2023-03-01",
      "2023-04-01",
      "2023-05-01",
      "2023-06-01",
      "2023-07-01",
      "2023-08-01",
      "2023-09-01",
      "2023-10-01",
      "2023-11-01",
      "2023-12-01",
      "2024-01-01",
      "2024-02-01",
      "2024-03-01",
      "2024-04-01",
      "2024-05-01",
      "2024-06-01",
      "2024-07-01",
      "2024-08-01",
      "2024-09-01",
      "2024-10-01",
      "2024-11-01",
      "2024-12-01",
      "2025-01-01",
      "2025-02-01",
      "2025-03-01",
      "2025-04-01",
      "2025-05-01",
      "2025-06-01",
      "2025-07-01",
      "2025-08-01",
      "2025-09-01",
      "2025-10-01",
      "2025-11-01",
      "2025-12-01"
    ]
  },
  "rmi": {
    "chlorophyll": [
      "1997-09-04",
      "1997-10-01",
      "1997-11-01",
      "1997-12-01",
      "1998-01-01",
      "1998-02-01",
      "1998-03-01",
      "1998-04-01",
      "1998-05-01",
      "1998-06-01",
      "1998-07-01",
      "1998-08-01",
      "1998-09-01",
      "1998-10-01",
      "1998-11-01",
      "1998-12-01",
      "1999-01-01",
      "1999-02-01",
      "1999-03-01",
      "1999-04-01",
      "1999-05-01",
      "1999-06-01",
      "1999-07-01",
      "1999-08-01",
      "1999-09-01",
      "2026-06-01"
    ],
    "phytoplankton_size": [
      "2025-12-01"
    ]
  }
};
